<div class="responsive-card gap-4">
  <div i18n class="responsive-card-title">Withdrawal Instructions</div>
  <div i18n class="subtitle">The payments will be made with the withdrawal percentages outlined below</div>
  <div class="funds-grid">
    <div *ngFor="let instruction of activeInstructions" class="fund-card inner-card d-flex flex-column gap-2">
      <div class="fund-indicator" [style.background-color]="instruction.fund?.colour"></div>
      <div class="label-md">{{ instruction.fund?.name }}</div>
      <div class="paragraph-lg">{{ instruction.percentage | number : '1.2-2' }}%</div>
    </div>
  </div>
</div>
